import { useMemo } from 'react';

interface InputProps {
  name?: any;
  type?: any;
  label?: any;
  onChange?: any;
  values?: any;
  autoFocus?: any;
  onBlur?: any;
  placeholder?: string;
  onKeyDown?: any;
  defaultValue?: any;
  touches?: any;
  errors?: any;
  disabled?: boolean;
  className?: string;
  readOnly?: boolean;
  min?: number;
}

export const Input: React.FC<InputProps> = ({
  name,
  type = 'text',
  label,
  onChange,
  values,
  autoFocus,
  onBlur,
  placeholder,
  onKeyDown,
  defaultValue,
  touches,
  errors,
  className,
  disabled,
  min,
}) => {
  const isInvalid = useMemo(() => {
    return touches?.[name] && errors?.[name];
  }, [touches, errors, name]);
  return (
    <div className='space-y-1 w-full relative'>
      <label
        htmlFor={name}
        className={`text-[11px] font-bold text-Black`}
      >
        {label}
      </label>
      <input
        id={name}
        name={name}
        type={type}
        min={min}
        onChange={onChange}
        value={values?.[name]}
        autoFocus={autoFocus}
        onBlur={onBlur}
        placeholder={placeholder}
        onKeyDown={onKeyDown}
        defaultValue={defaultValue}
        onWheel={(e: any) => e.target.blur()}
        className={
          className
            ? className
            : 'flex items-center px-2 pl-4 py-2.5 border focus:outline-none focus:border-gray-700 border-pureWhite/30 rounded-md text-xs bg-pureBlack/30 text-textGray w-full'
        }
        disabled={disabled}
      />
      {isInvalid ? (
        <div
          style={{ color: '#ef4444' }}
          className='font-semibold text-[10px] absolute'
        >
          {errors[name]}
        </div>
      ) : null}
    </div>
  );
};
